import { looksLikeLineEmbeddedBrowser } from "@/lib/openLineExternalBrowser";

export type GoogleIntegrationsConnectOptions = {
  serviceId: string;
  callbackUrl: string;
  auto?: boolean;
  /** Optional destination when user cancels /login/external UI. */
  cancelTo?: string;
  /**
   * Sheets reconnect from `/signin/sheets-expired` — omit `callbackUrl` from the
   * query string so `/login/external` can resolve `aera_last_workspace` at OAuth start
   * (avoids fragile `callbackUrl=/?workspaceId=…` parsing).
   */
  sheetsReconnect?: boolean;
};

export function buildGoogleIntegrationsExternalPath(
  options: GoogleIntegrationsConnectOptions,
): string {
  const q = new URLSearchParams();
  if (options.auto !== false) q.set("auto", "1");
  q.set("flow", "integrations");
  if (options.sheetsReconnect) {
    q.set("reconnect", "1");
  } else {
    q.set("callbackUrl", options.callbackUrl);
  }
  q.set("serviceId", options.serviceId.trim());
  if (options.cancelTo?.trim()) q.set("cancelTo", options.cancelTo.trim());
  return `/login/external?${q.toString()}`;
}

/** Start Google Drive/Sheets OAuth — same navigation as FinancialAdmin `handleConnect`. */
export function navigateToGoogleIntegrationsConnect(
  options: GoogleIntegrationsConnectOptions,
  onNavigate?: (path: string) => void,
): void {
  if (typeof window === "undefined") return;

  const path = buildGoogleIntegrationsExternalPath(options);
  const liffId = (
    options.sheetsReconnect
      ? process.env.NEXT_PUBLIC_LINE_LIFF_ID_SIGNIN
      : process.env.NEXT_PUBLIC_LINE_LIFF_ID_LOGIN
  )?.trim() || "";

  if (
    liffId &&
    liffId.includes("-") &&
    (window.location.hostname === "liff.line.me" ||
      looksLikeLineEmbeddedBrowser())
  ) {
    window.location.href = `https://liff.line.me/${liffId}?path=${encodeURIComponent(path)}`;
    return;
  }

  if (onNavigate) {
    onNavigate(path);
    return;
  }

  window.location.assign(path);
}
